import { AGREE_DISAGREE_TYPES } from "./consultations";

const negatePrefixMap: Record<string, string> = {
  "I have no ": "I have ",
  "I don’t ": "I ",
  "I don't ": "I ",
  "I am not ": "I am ",
  "I’m not ": "I’m ",
  "I cannot ": "I can ",
  "I can’t ": "I can ",
};

const stripTrailingPeriod = (str: string): string =>
  str.trim().replace(/\.$/, "");

const normalizeTitle = (title: string): string => stripTrailingPeriod(title);

const invertNegation = (title: string): string => {
  const cleanTitle = stripTrailingPeriod(title);
  for (const [negated, positive] of Object.entries(negatePrefixMap)) {
    if (cleanTitle.startsWith(negated)) {
      return cleanTitle.replace(negated, positive);
    }
  }
  return cleanTitle;
};

export const formatAgreeDisagreeValue = (
  input: string,
  title: string,
): string => {
  if (input === AGREE_DISAGREE_TYPES.agree) {
    return `Agree, ${normalizeTitle(title)}`;
  }

  if (input === AGREE_DISAGREE_TYPES.disagree) {
    return `Disagree, ${invertNegation(title)}`;
  }

  return stripTrailingPeriod(title);
};
